var _defs, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgReports = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 176.25 176.25"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Reports_svg__cls-1{fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:11.25px;stroke-linecap:square}"))), /*#__PURE__*/React.createElement("g", {
  id: "Reports_svg__Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Reports_svg___\\xCE\\xD3\\xC8_1",
  "data-name": "\\u2014\\xCE\\xD3\\xC8_1"
}, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  className: "Reports_svg__cls-1",
  cx: 88.13,
  cy: 88.13,
  r: 82.5
})), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: "11.25px"
  },
  d: "M88.13 5.63v82.5"
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "Reports_svg__cls-1",
  d: "m30.59 30.59 57.54 57.54h82.5"
})))));
export default SvgReports;